export default {
  bar: 0,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/components/Vuetify/mixins/application.js
// module id = null
// module chunks = 